export const CHECKOUT_URL = 'https://smart-home-installer-pro.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offer'

export const PRODUCT_NAME = 'SMART HOME INSTALLER PRO™'

export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/rsPVom4ohM5bNBE6usjKcb/ChatGPT-Image-5-ago-2026_-07_29_51-p.m..webp'
